import { n8nRequest, N8N_CONFIG } from '../config/n8n-config';

// Стоимость различных AI услуг (legacy, используется как fallback)
export const SERVICE_PRICES = {
  'replace_model': 11,
  'replace_background': 11,
  'upscale': 11,
  'object_background': 11,
  'photo_session': 11,
  'changing_room': 11,
  'photo_to_video': 72,
  'auto_product_card': 14,
  'photo_generation': 22,
  'vector_ai': 22
};

// Единая таблица цен по моделям (заменяет pro_mode логику)
export const MODEL_PRICES = {
  'nano-banana-2-lite': { '1K': 5 },
  'nano-banana-2':     { '1K': 10, '2K': 18, '4K': 26 }, // KIE шлём nano-banana-2-1 ($0.02/0.03/0.045), −20% от прежних 13/22/32
  'flux-3-klein':      { '1K': 6, '2K': 10, '4K': 20 }, // KIE flux-3/klein-* $0.008/0.0125/0.0325 (kie.ai/flux-3, 2026-10-22)
  'wan/2-7-image':     { '1K': 13, '2K': 13 },
  'wan/2-7-image-pro': { '1K': 13, '2K': 16, '4K': 22 },
  'nano-banana-pro':   { '1K': 22, '2K': 22, '4K': 32 },
  'gpt-image-2':       { '1K': 13, '2K': 22, '4K': 32 },
  'gpt-image-2-5':     { '1K': 13, '2K': 22, '4K': 32 },
  'recraft-v4.1-vector': { '1K': 22 },
  'quiver-arrow-1.1':    { '1K': 32 }
};

// Видео считается не по разрешению, а по секундам: ставка кредитов за секунду по модели и
// разрешению, цена = ставка × секунды (×2 при аудио).
//
// Таблица дублируется в n8n `/deduct-credits` (узел Validate Request) — ровно так же, как
// MODEL_PRICES. Сервер ПЕРЕСЧИТЫВАЕТ цену по kie_model + resolution + duration + generate_audio
// и отклоняет весь запрос, если присланный amount не сошёлся (`expectedPrice !== amount` → 400).
// Расхождение этих двух таблиц = отказ на списании = бесплатная генерация, причём молча.
// Кросс-проверка обеих таблиц — n8n-flows/test-deduct-credits-idempotency.py.
//
// Наценка 2 и 2.5 — как у nano-banana-pro (22 кр. за $0.09 ≈ 244 кр. на $1 себестоимости KIE,
// kie.ai/pricing 07.10.2026) минус 10% по решению владельца. «+video» — с референс-видео: KIE берёт (вход + выход) секунд по
// ставке «with video», а выход = входу, поэтому за секунду ролика 2 × ставка «with video».
// mini дороже этой планки и в обоих режимах, её не трогали.
export const VIDEO_RATES = {
  'bytedance/seedance-2-mini': { '480p': 7, '720p': 14, '480p+video': 7, '720p+video': 14 },
  'bytedance/seedance-2':      { '480p': 21, '720p': 45, '480p+video': 25, '720p+video': 55 },
  'bytedance/seedance-2-5':    { '480p': 31, '720p': 69, '480p+video': 38, '720p+video': 84 }
};

// Расчёт цены по модели и разрешению/качеству
export const getModelPrice = (kieModel, options = {}) => {
  const videoRates = VIDEO_RATES[kieModel];
  if (videoRates) {
    const duration = Number(options.duration);
    // Без длительности цену видео посчитать нельзя. Возвращаем null («цена неизвестна»), а не
    // NaN: NaN проваливает любое сравнение (currentCredits < NaN === false), и проверка баланса
    // молча пропустила бы задачу, за которую потом нечем платить.
    if (!Number.isFinite(duration) || duration <= 0) return null;
    const rate = videoRates[options.video_input ? `${options.resolution}+video` : options.resolution] || videoRates['480p'];
    const price = rate * duration;
    return options.generate_audio ? price * 2 : price;
  }
  const modelPrices = MODEL_PRICES[kieModel];
  if (!modelPrices) return null;
  const resolution = options.resolution || '1K';
  return modelPrices[resolution] || 14;
};

// Функция для получения текущего пользователя из localStorage
export const getCurrentUser = () => {
  try {
    const userData = localStorage.getItem('userData');
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error('Ошибка получения данных пользователя:', error);
    return null;
  }
};

// Функция для обновления данных пользователя в localStorage
export const updateUserData = (newUserData) => {
  try {
    localStorage.setItem('userData', JSON.stringify(newUserData));
    console.log('Данные пользователя обновлены:', newUserData);
    
    // Отправляем кастомное событие для уведомления компонентов об изменении
    const event = new CustomEvent('userDataUpdated', { 
      detail: newUserData 
    });
    window.dispatchEvent(event);
  } catch (error) {
    console.error('Ошибка обновления данных пользователя:', error);
  }
};

// Функция для проверки баланса кредитов
export const checkCreditsBalance = (serviceType, isProMode = false, kieModel = null, options = null) => {
  const user = getCurrentUser();
  if (!user) {
    throw new Error('Пользователь не авторизован');
  }

  const basePrice = SERVICE_PRICES[serviceType];
  if (!basePrice) {
    throw new Error('Неизвестный тип услуги');
  }

  let price;
  if (options && kieModel) {
    const modelPrice = getModelPrice(kieModel, options);
    price = modelPrice || basePrice;
  } else {
    price = isProMode ? basePrice * 3 : basePrice;
  }

  const currentCredits = user.credits || 0;

  if (currentCredits < price) {
    throw new Error(`Недостаточно кредитов. У вас: ${currentCredits}, требуется: ${price}`);
  }

  return {
    currentCredits,
    price,
    hasEnoughCredits: true
  };
};

// Функция для списания кредитов
// taskId — необязательный ключ идемпотентности. Если передан, уходит в payload как task_id,
// и сервер спишет кредиты за эту задачу ровно один раз (повторный вызов вернёт текущий баланс
// и success: true, ничего не списывая). Без taskId payload не меняется.
export const deductCredits = async (serviceType, isProMode = false, kieModel = null, options = null, taskId = null) => {
  const user = getCurrentUser();
  if (!user) {
    throw new Error('Пользователь не авторизован');
  }

  const basePrice = SERVICE_PRICES[serviceType];
  if (!basePrice) {
    throw new Error('Неизвестный тип услуги');
  }

  let price;
  if (options && kieModel) {
    const modelPrice = getModelPrice(kieModel, options);
    price = modelPrice || basePrice;
  } else {
    price = isProMode ? basePrice * 3 : basePrice;
  }

  try {
    console.log(`Списание кредитов за ${serviceType}:`, {
      user_id: user.id,
      amount: price,
      current_balance: user.credits,
      kie_model: kieModel,
      options
    });

    const requestData = {
      user_id: user.id,
      amount: price,
      service_type: serviceType
    };

    // Новый формат: передаём kie_model, resolution, quality
    if (kieModel) {
      requestData.kie_model = kieModel;
    }
    if (options) {
      if (options.resolution) requestData.resolution = options.resolution;
      // Видео: сервер пересчитывает цену по секундам и аудио. Без этих полей его формула даст
      // другое число, и списание будет отклонено целиком (см. VIDEO_RATES выше).
      if (options.duration !== undefined) requestData.duration = Number(options.duration);
      if (options.generate_audio !== undefined) requestData.generate_audio = !!options.generate_audio;
      if (options.video_input) requestData.video_input = true;
    } else {
      // Legacy: передаём pro_mode для необновлённых компонентов
      requestData.pro_mode = isProMode;
    }
    // Ключ идемпотентности. Пустой/отсутствующий task_id — сервер ведёт себя ровно как раньше.
    if (taskId) {
      requestData.task_id = String(taskId);
    }

    const response = await n8nRequest(N8N_CONFIG.ENDPOINTS.DEDUCT_CREDITS, requestData);

    if (response.success) {
      // Обновляем данные пользователя в localStorage
      const updatedUser = {
        ...user,
        credits: response.new_balance
      };
      updateUserData(updatedUser);

      console.log('Кредиты успешно списаны:', {
        previous_balance: response.previous_balance,
        deducted: response.deducted_amount,
        new_balance: response.new_balance
      });

      return {
        success: true,
        previousBalance: response.previous_balance,
        deductedAmount: response.deducted_amount,
        newBalance: response.new_balance,
        message: response.message
      };
    } else {
      throw new Error(response.error || 'Ошибка списания кредитов');
    }
  } catch (error) {
    console.error('Ошибка списания кредитов:', error);
    throw error;
  }
};

// Функция для отображения информации о стоимости
export const getCostInfo = (serviceType, isProMode = false, kieModel = null, options = null) => {
  const basePrice = SERVICE_PRICES[serviceType];

  let price;
  if (options && kieModel) {
    const modelPrice = getModelPrice(kieModel, options);
    price = modelPrice || basePrice;
  } else {
    price = isProMode ? basePrice * 3 : basePrice;
  }

  const user = getCurrentUser();
  const currentCredits = user ? user.credits || 0 : 0;

  return {
    price,
    currentCredits,
    hasEnoughCredits: currentCredits >= price,
    serviceName: getServiceName(serviceType)
  };
};

// Функция для получения человекочитаемого названия услуги
export const getServiceName = (serviceType) => {
  const names = {
    'replace_model': 'Замена модели',
    'replace_background': 'Замена фона', 
    'upscale': 'Увеличение разрешения',
    'object_background': 'Предметная съемка',
    'photo_session': 'Фотосессия',
    'changing_room': 'Примерочная',
    'photo_to_video': 'Оживление фото',
    'auto_product_card': 'Авто карточка товара',
    'photo_generation': 'Генерация фото',
    'vector_ai': 'Векторная AI'
  };
  return names[serviceType] || serviceType;
};

// Синхронизация баланса с сервером
export const syncUserBalance = async () => {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) return null;

    const response = await n8nRequest(N8N_CONFIG.ENDPOINTS.VERIFY_TOKEN, { token });
    
    if (response.valid && response.user) {
      updateUserData(response.user);
      console.log('Баланс синхронизирован:', response.user.credits);
      return response.user;
    }
    return null;
  } catch (error) {
    console.error('Ошибка синхронизации баланса:', error);
    return null;
  }
};

// Apply promo code via n8n workflow and update user credits
export const applyPromoCode = async (promoCode) => {
  const user = getCurrentUser();
  if (!user) {
    throw new Error('User is not authenticated');
  }

  const normalizedCode = typeof promoCode === 'string' ? promoCode.trim() : '';
  if (!normalizedCode) {
    throw new Error('Promo code is required');
  }

  try {
    const response = await n8nRequest(N8N_CONFIG.ENDPOINTS.APPLY_PROMO, {
      user_id: user.id,
      promo_code: normalizedCode,
      email: user.email,
      full_name: user.full_name
    });

    if (!response?.success) {
      throw new Error(response?.error || 'Promo code validation failed');
    }

    const updatedUser = {
      ...user,
      credits: response.new_balance
    };
    updateUserData(updatedUser);

    const addedCredits = response.added_credits ?? 0;
    return {
      success: true,
      addedCredits,
      newBalance: response.new_balance,
      message: response.message || `Promo code applied: +${addedCredits} credits`,
      payload: response
    };
  } catch (error) {
    console.error('applyPromoCode error:', error);
    throw error;
  }
};
